import { useQuery } from '@tanstack/react-query';
import { fetchHealth } from '../api/health.api';

export const healthQueryKey = ['health'] as const;

export const useHealth = () =>
  useQuery({
    queryKey: healthQueryKey,
    queryFn: fetchHealth,
    refetchInterval: 15_000,
  });
